import { render, staticRenderFns } from "./RestaurantsFilter.vue?vue&type=template&id=47c2e984&"
import script from "./RestaurantsFilter.vue?vue&type=script&lang=js&"
export * from "./RestaurantsFilter.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantsFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports